import React, { useState } from "react";
import { Link } from "react-router-dom";
// import IconSocalFurs from './SocalDate.jpg'
import IconSocalFurs from './Socalfurs.jpg'
import './AboutPage.css'

export default function OurGroups() {

  return (

       <div className = "about-us-main-container">
                  {/* <img className="homepage-main-icon" src={AfcImage} alt="Socalfurs.com" /> */}

            <div className = "about-us-container-1">
                      <header className = "about-us-header">Our Groups & Socials</header>
                      <p className = "about-us-p">
                            In addition to attending in-person events, staying connected online is a big
                            part of the furry community. Whether you're new or a longtime member, there
                            are several places where you can meet others, share content, and get updates.
                            View our Calendar Page here: <Link to ="/calendar">Local Furry Meet Calendar</Link>
                        </p>
                     <h2>Discord Server</h2>
                       <p className="about-us-p">
                            This is our sister discord Server:   <a href="https://discord.gg/nXGUjUpXQG" target="_blank" rel="noopener noreferrer">Southern California Furries Discord</a> 
                        </p>
                        <p className="about-us-p"> This is one of the best places to chat, share art, coordinate for meetups, 
                            and hang out virtually. We have dedicated channels for different regions, 
                            events, interests, and general conversation. It's a welcoming space whether 
                            you're local or just visiting.</p>
                        <h2>Telegram Groups</h2>
                          <p className = "about-us-p">
                            Telegram remains our main tool for real-time updates and chat. Most events have their own 
                            Telegram group or channel where organizers share details, timing, and last-minute changes. 
                            If you're attending an event, joining its Telegram group is highly recommended. We have multiple
                            Telegram Channels and Groups To Join!
                            <ul>

                                <li><a href= "https://t.me/+LPKHccQiNR03ZDQ7">Socal Furs Telegram Chat</a></li>
                                <li><a href= "https://t.me/SouthernCaliforniaFurries">Sister Socal Telegram Chat</a></li>
                                <li><a href= "https://t.me/SoCalFursCalendar">Socal Furs Telegram Calendar Channel</a></li>
                                <li><a href= "https://t.me/SoCalfurchats">Socal Furs Telegram Chat List</a></li>
                        
                            </ul>
                        </p>
                        <h2>Furaffinity</h2>
                          <p className = "about-us-p">
                            Our <a href="">Furaffinity page</a> is where we showcase the creative side of our community. 
                            You'll find event photos, digital art, fursuit pictures, and other submissions 
                            from members who attend local meetups or just want to express themselves through art.
                        </p>
                       <h2>Twitter / X</h2>
                          <p className = "about-us-p">
                            Our <a href="https://twitter.com/" target="_blank" rel="noopener noreferrer">Twitter (X) </a> 
                            page is a great way to stay up-to-date with everything happening in the community. 
                            We use it to share quick updates, event announcements, photos, and highlights 
                            from local meetups. Whether it’s a last-minute change to an event, a cool photo 
                            someone took, or a shoutout to one of our amazing members, you’ll find it there.
                        </p>

                        <h2>Grovel's News Network</h2>
                        <p>SoCalFurs.com is Affliated with Grovel's News Network and <a href = "https://t.me/NorCalFursCalendar">The NorCalFurs Calendar </a>
                          Visit <a href = "https://t.me/GrovelReports">https://t.me/GrovelReports</a> for California Furry Fandom News and Alerts! 
                        </p>
         
            </div>

            <div className = "about-us-space"></div>
            <div className = "about-us-image-container">
              <img className = "about-us-img" src = {IconSocalFurs}></img>
            </div>
    
                      
        </div>

         
  );
}
